export default "__VITE_ASSET__a6e1a539__"